<template>
  <div>
    <!-- toast -->
    <div v-if="showMessage" class="toast align-items-center fade show position-fixed top-0 end-0"
      :class="messageType === 'error' ? 'text-bg-danger' : 'text-bg-success'" role="alert" aria-live="assertive"
      aria-atomic="true" data-bs-config='{"delay":5000, "autohide":true}' style="z-index: 9999">
      <div class="d-flex">
        <div class="toast-body">{{ statusMessage }}</div>
        <button type="button" class="btn-close me-2 m-auto" aria-label="Close" @click="showMessage = false"></button>
      </div>
    </div>
    <!-- end toast -->
    <div class="col-lg-12 text-end">
      <RouterLink :to="`/students/add/`" class="col-1 no-underline">
        <button type="button" class="btn btn-sm btn-success text-end btn-left">
          <i class="fa fa-plus" aria-hidden="true"></i>Add
        </button>
      </RouterLink>
    </div>
    <div class="col-lg-12">
      <div class="row g-2 align-items-end mb-3">
        <div class="col-md-2">
          <label class="form-label">Class</label>
          <div class="dropdown">
            <button class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a" type="button"
              data-bs-toggle="dropdown" aria-expanded="false">
              {{uniqueClsList.find((item) => item._id === filters.clsID)?.name || "Select class"}}
            </button>
            <ul class="dropdown-menu w-100 scrollable-menu">
              <li v-for="item in uniqueClsList" :key="item._id">
                <a class="dropdown-item" href="#" @click.prevent="filters.clsID = item._id; filters.sectionID = ''">
                  {{ item.name }}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md-2">
          <label class="form-label" for="student-section-filter">Section</label>
          <select id="student-section-filter" v-model="filters.sectionID" class="form-select form-select-sm">
            <option value="">Select section</option>
            <option v-for="item in secList" :key="item._id" :value="item._id">
              {{ item.Name }}
            </option>
          </select>
        </div>
        <div class="col-md-1">
          <button type="button" class="btn btn-sm btn-success" :disabled="progress !== 0" @click="loadStudents">
            <i class="fa fa-search me-1" aria-hidden="true"></i>Go
          </button>
        </div>
      </div>
      <div class="col-lg-12 table-responsive">
        <div class="progress mb-0 progress-sm" v-if="progress != 0">
          <div class="progress-bar" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"
            :style="{ width: progress + '%' }"></div>
        </div>
        <DataTable v-if="progress == 0" :columns="cols" :rows="rows" :pageSize="10" :actions="{
          view: handleView,
          edit: handleEdit,
          delete: handleDelete,
        }" />
      </div>
      <div v-if="showModal" class="modal fade show d-block" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-lg modal-fullscreen-sm-down" role="document">
          <div class="modal-content">
            <div class="modal-header ms-1">
              <h5 class="modal-title color-darknavy">
                Student {{ [Obj.firstName, Obj.lastName].filter(Boolean).join(" ") }} Details
              </h5>
              <button type="button" class="btn-close" @click="closeModal"></button>
            </div>

            <div class="modal-body row ms-1 me-1 ps-0">
              <div class="col-12 col-md-5 order-1 order-md-0 mb-3">
                <div v-for="field in studentFields" :key="field.path" class="row mb-1">
                  <div class="col-6 col-md-5 text-start">
                    <strong>{{ field.label }}</strong>
                  </div>
                  <div class="col-6 col-md-7 d-flex align-items-center gap-1">
                    <template v-if="editingField === field.path">
                      <select v-if="field.options" v-model="editDraft" class="form-select form-select-sm"
                        :aria-label="`Edit ${field.label}`">
                        <option v-for="option in fieldOptions(field)" :key="option.value" :value="option.value">
                          {{ option.label }}
                        </option>
                      </select>
                      <input v-else v-model="editDraft" :type="field.type || 'text'"
                        class="form-control form-control-sm" :aria-label="`Edit ${field.label}`" />
                      <button type="button" class="btn btn-link btn-sm p-0" :disabled="!!savingField"
                        :aria-label="`Save ${field.label}`" title="Save" @click="saveField(field)">
                        <i class="fa fa-save text-success" aria-hidden="true"></i>
                      </button>
                      <button type="button" class="btn btn-link btn-sm p-0" :disabled="!!savingField"
                        :aria-label="`Cancel editing ${field.label}`" title="Cancel" @click="cancelFieldEdit">
                        <i class="fa fa-times text-secondary" aria-hidden="true"></i>
                      </button>
                    </template>
                    <template v-else>
                      <span>: {{ displayField(field) }}</span>
                      <button type="button" class="btn btn-link btn-sm p-0" :aria-label="`Edit ${field.label}`"
                        :title="`Edit ${field.label}`" @click="beginFieldEdit(field)">
                        <i class="fa fa-pencil text-primary" aria-hidden="true"></i>
                      </button>
                    </template>
                  </div>
                </div>
                <div class="row mb-1" v-if="Obj.aadharImage">
                  <div class="col-6 col-md-5 text-start">
                    <strong>Aadhar Photo</strong>
                  </div>
                  <div class="col-md-7 col-6 text-start">
                    :
                    <a :href="getUrl(Obj.aadharImage)" target="_blank" class="clearfix"><img
                        :src="getUrl(Obj.aadharImage)" class="avatar-sm rounded cursor-pointer" role="button"
                        alt="Student Image" /></a>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6 order-1 order-md-0 mb-3">
                <div v-for="field in parentFields" :key="field.path" class="row mb-1">
                  <div class="col-6 col-md-4 text-start">
                    <strong>{{ field.label }}</strong>
                  </div>
                  <div class="col-6 col-md-8 d-flex align-items-center gap-1">
                    <template v-if="editingField === field.path">
                      <select v-if="field.options" v-model="editDraft" class="form-select form-select-sm"
                        :aria-label="`Edit ${field.label}`">
                        <option v-for="option in fieldOptions(field)" :key="option.value" :value="option.value">
                          {{ option.label }}
                        </option>
                      </select>
                      <input v-else v-model="editDraft" :type="field.type || 'text'"
                        class="form-control form-control-sm" :aria-label="`Edit ${field.label}`" />
                      <button type="button" class="btn btn-link btn-sm p-0" :disabled="!!savingField"
                        :aria-label="`Save ${field.label}`" title="Save" @click="saveField(field)">
                        <i class="fa fa-save text-success" aria-hidden="true"></i>
                      </button>
                      <button type="button" class="btn btn-link btn-sm p-0" :disabled="!!savingField"
                        :aria-label="`Cancel editing ${field.label}`" title="Cancel" @click="cancelFieldEdit">
                        <i class="fa fa-times text-secondary" aria-hidden="true"></i>
                      </button>
                    </template>
                    <template v-else>
                      <span>: {{ displayField(field) }}</span>
                      <button type="button" class="btn btn-link btn-sm p-0" :aria-label="`Edit ${field.label}`"
                        :title="`Edit ${field.label}`" @click="beginFieldEdit(field)">
                        <i class="fa fa-pencil text-primary" aria-hidden="true"></i>
                      </button>
                    </template>
                  </div>
                </div>
                <div class="row mb-1" v-if="Obj.parent?.aadharPhoto">
                  <div class="col-6 col-md-4 text-start">
                    <strong>Parent Aadhar</strong>
                  </div>
                  <div class="col-md-8 col-6 text-start">
                    :
                    <a :href="getUrl(Obj.parent?.aadharPhoto)" target="_blank" class="clearfix"><img
                        :src="getUrl(Obj.parent?.aadharPhoto)" class="avatar-sm rounded cursor-pointer" role="button"
                        alt="Student Image" /></a>
                  </div>
                </div>
                <div class="row mb-1" v-if="Obj.tc">
                  <div class="col-6 col-md-4 text-start">
                    <strong>TC</strong>
                  </div>
                  <div class="col-md-8 col-6 text-start">
                    :
                    <a :href="getUrl(Obj.tc)" target="_blank" class="clearfix"><img :src="getUrl(Obj.tc)"
                        class="avatar-sm rounded cursor-pointer" role="button" alt="Student Image" /></a>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-1 text-center order-0 order-md-2 mb-3 mb-md-0 ms-md-n4">
                <img :src="getUrl(Obj?.image)" class="rounded-circle avatar-xl mb-2 cursor-pointer" role="button"
                  alt="Student Image" />
              </div>
            </div>

            <div class="modal-footer">
              <button class="btn btn-info btn-sm" @click="closeModal">
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <DelPopup :name="delObj.firstName" @delRecord="delRecord" @closeModal="delObj.firstName = ''"></DelPopup>
  </div>
</template>
<script setup>
import DelPopup from "@/components/Common/DelPopup.vue";
import DataTable from "@/components/Common/DataTable.vue";
import { formatDate, api } from "@/utils/helpers.js";
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
const router = useRouter();
import { schoolStore } from "@/utils/schoolStore";
const { clsList, uniqueClsList, secList } = schoolStore();
const filters = ref({ clsID: "", sectionID: "" });
const Obj = ref({});
const delObj = ref({});
const showMessage = ref(false);
const showModal = ref(false);
const cols = ref([
  { label: "Roll No", key: "rollNo" },
  { label: "Admin No", key: "admissionNumber" },
  { label: "Name", key: "fullName" },
  { label: "Gender", key: "gender" },
  { label: "Photo", key: "image", type: "image" },
  { label: "Class", key: "class" },
  { label: "Father Name", key: "fatherName" },
  { label: "Mobile", key: "phone" },
  { label: " Category", key: "categoryID" },
]);
const categories = ref([]);
const statusMessage = ref("");
const messageType = ref("success");
const editingField = ref("");
const editDraft = ref("");
const savingField = ref("");
const studentFields = [
  { label: "First Name", path: "firstName" },
  { label: "Last Name", path: "lastName" },
  { label: "Admission No", path: "admissionNumber" },
  { label: "Roll No", path: "rollNo" },
  { label: "Class", path: "clsID", options: "classes" },
  { label: "Section", path: "sectionID", options: "sections" },
  { label: "Gender", path: "gender", options: "gender" },
  { label: "Date of Birth", path: "dob", type: "date" },
  { label: "Religion", path: "parent.relId" },
  { label: "Student Aadhaar No.", path: "aadharNumber" },
  { label: "Blood Group", path: "bloodGroup" },
];
const parentFields = [
  { label: "Father Name", path: "parent.fatherName" },
  { label: "Mother Name", path: "parent.motherName" },
  { label: "Phone No", path: "parent.phone" },
  { label: "Alternate No", path: "parent.altNo" },
  { label: "Category", path: "parent.categoryID", options: "categories" },
  { label: "Father Profession", path: "parent.fatherProfession" },
  { label: "Mother Profession", path: "parent.motherProfession" },
  { label: "Email", path: "parent.email", type: "email" },
  { label: "Parent Aadhaar No.", path: "parent.aadharNumber" },
  { label: "Address", path: "parent.address" },
];

const loadCategories = async () => {
  const res = await api.get("/Category/all");
  categories.value = res.data;
};
const handleView = (row) => {
  Obj.value = {
    ...row,
    parent: { ...row.parent },
  };

  cancelFieldEdit();
  showModal.value = true;
};
const closeModal = () => {
  cancelFieldEdit();
  showModal.value = false;
};
const handleEdit = (row) => {
  router.push(`/students/add?id=${row._id}`);
};
const handleDelete = (row) => {
  delObj.value = { ...row };
};
const rows = ref([]);
const disDate = (d) => {
  return formatDate(d);
};
const getFieldValue = (path) =>
  path.split(".").reduce((value, key) => value?.[key], Obj.value);
const setFieldValue = (path, value) => {
  const keys = path.split(".");
  const property = keys.pop();
  const target = keys.reduce((object, key) => object[key], Obj.value);
  target[property] = value;
};
const fieldOptions = (field) => {
  if (field.options === "classes") {
    return clsList.value.map((item) => ({ value: item._id, label: item.name }));
  }
  if (field.options === "sections") {
    return secList.value.map((item) => ({ value: item._id, label: item.Name }));
  }
  if (field.options === "categories") {
    return categories.value.map((item) => ({ value: item._id, label: item.Name }));
  }
  if (field.options === "gender") {
    return ["Male", "Female", "Other"].map((value) => ({ value, label: value }));
  }
  return [];
};
const displayField = (field) => {
  const value = getFieldValue(field.path);
  if (field.options) {
    return fieldOptions(field).find((option) => option.value === value)?.label || "";
  }
  return field.type === "date" ? disDate(value) : value || "";
};
const beginFieldEdit = (field) => {
  editingField.value = field.path;
  const value = getFieldValue(field.path);
  editDraft.value =
    field.type === "date" && value
      ? new Date(value).toISOString().slice(0, 10)
      : value || "";
};
const cancelFieldEdit = () => {
  editingField.value = "";
  editDraft.value = "";
};
const saveField = async (field) => {
  if (!Obj.value._id || savingField.value) return;

  const previousValue = getFieldValue(field.path);
  setFieldValue(field.path, editDraft.value);
  savingField.value = field.path;
  try {
    const formData = new FormData();
    [
      "firstName",
      "lastName",
      "penNo",
      "clsID",
      "sectionID",
      "rollNo",
      "admissionNumber",
      "dob",
      "gender",
      "bloodGroup",
      "aadharNumber",
      "aadharImage",
      "image",
      "tc",
    ].forEach((key) => formData.append(key, Obj.value[key] ?? ""));
    const parentDetails = {
      fatherName: Obj.value.parent?.fatherName || "",
      motherName: Obj.value.parent?.motherName || "",
      email: Obj.value.parent?.email || "",
      phone: Obj.value.parent?.phone || "",
      altNo: Obj.value.parent?.altNo || "",
      bloodGroup: Obj.value.parent?.bloodGroup || "",
      categoryID: Obj.value.parent?.categoryID || "",
      relId: Obj.value.parent?.relId || "",
      address: Obj.value.parent?.address || "",
      aadharNumber: Obj.value.parent?.aadharNumber || "",
      fatherProfession: Obj.value.parent?.fatherProfession || "",
      motherProfession: Obj.value.parent?.motherProfession || "",
      aadharPhoto: Obj.value.parent?.aadharPhoto || "",
      parentId: Obj.value.parent?._id || Obj.value.parent?.parentId || "",
    };
    formData.append("parentDetails", JSON.stringify(parentDetails));
    await api.put(`/students/${Obj.value._id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    statusMessage.value = "Student updated successfully.";
    messageType.value = "success";
    showMessage.value = true;
    cancelFieldEdit();
    //await loadData();
  } catch (error) {
    setFieldValue(field.path, previousValue);
    statusMessage.value = "Unable to update student details.";
    messageType.value = "error";
    showMessage.value = true;
    console.error("Failed to update student", error);
  } finally {
    savingField.value = "";
  }
};
const progress = ref(0);
const loadData = async (clsID, sectionID) => {
  progress.value = 1;
  try {
    if (clsID && sectionID) {
      const response = await api.get(`/students/clssection/${clsID}/${sectionID}`);
      rows.value = (response.data || [])
        .map((item) => ({
          ...item,
          fullName: `${item.firstName || ""} ${item.lastName || ""}`.trim(),
          class: `${clsList.value.find((c) => c._id === item.clsID)?.name || ""}${clsList.value.find((c) => c._id === item.clsID)?.name
            ? secList.value.find((s) => s._id === item.sectionID)?.Name
              ? " (" +
              secList.value.find((s) => s._id === item.sectionID)?.Name +
              ")"
              : ""
            : ""
            }`,
          image: item.image,
          fatherName: item.parent?.fatherName,
          phone: item.parent?.phone,
          categoryID:
            categories.value.find((c) => c._id === item.parent?.categoryID)
              ?.Name || "",
          relId: item.parent?.relId,
        }))
        .sort((a, b) => a.class.localeCompare(b.class));
    } else {
      rows.value = [];
    }

  } catch (error) {
    statusMessage.value = "Unable to load students.";
    messageType.value = "error";
    showMessage.value = true;
    console.error("Failed to load students", error);
  } finally {
    progress.value = 0;
  }
};
const loadStudents = () => {
  if (!filters.value.clsID || !filters.value.sectionID) {
    statusMessage.value = "Select a class and section first.";
    messageType.value = "error";
    showMessage.value = true;
    return;
  }
  loadData(filters.value.clsID, filters.value.sectionID);
};
const delRecord = async () => {
  await api.delete(`/students/${delObj.value._id}`).then(() => {
    loadData();
    delObj.value = {};
    statusMessage.value = "Student deleted successfully.";
    messageType.value = "success";
    showMessage.value = true;
  });
};
const getUrl = (img) => {
  let imgUrl = img.startsWith("..") ? img.substring(2) : img;

  const base = process.env.VUE_APP_API_URL.replace(/\/+$/, "");
  const path = imgUrl.replace(/^\/+/, "");
  return `${base}/${path}`;
};
onMounted(() => {
  loadData();
  loadCategories();
});
</script>
<style>
.modal {
  z-index: 9999 !important;
}

.modal-content {
  max-height: 90vh;
  overflow-y: auto;
  overflow-x: hidden;
}

@media (max-width: 576px) {
  .modal-content {
    border-radius: 0;
  }
}
</style>
